// Modul zur Erfassung eines Durchführungszeitraums
"use strict";

import module from "./module.js";
// import "./tests.spec.js";

export default module;
